<template>
<q-page class="main">
  <common-form :action="$route('category.subcategory.update', {category: category.id, subcategorie: subcategory.id})"
               is-update>
    <q-card class="page-card">
      <q-card-section class="page-card__main-content">
        <h1 class="heading-2 q-mb-lg">Bewerk subcategorie {{ subcategory.title }}</h1>
        <subcategory-form :subcategory="subcategory" />
      </q-card-section>
      <template v-if="$isDesktop">
        <q-separator />
        <q-card-actions align="right" class="q-pa-md">
          <warning-button label="Verwijder" @click="deleteSubcategory" />
          <accent-button label="Opslaan" type="submit" />
        </q-card-actions>
      </template>
    </q-card>
    <sticky-top-bar />
    <sticky-bottom-bar v-if="!$isDesktop">
      <common-fab icon="done" label="Opslaan" type="submit" />
    </sticky-bottom-bar>
  </common-form>
</q-page>
</template>

<script>
import SubcategoryForm from './SubcategoryForm'

export default {
  props: {
    category: {
      type: Object,
      default: null,
    },
    subcategory: {
      type: Object,
      default: null,
    },
  },
  components: {
    SubcategoryForm,
  },

  methods: {
    async deleteSubcategory() {
      if (!await this.$confirm({ title: 'Weet u zeker dat u deze subcategorie wilt verwijderen?' })) {
        return
      }
      try {
        await axios.delete(this.$route('category.subcategory.destroy', {
          category: this.category.id,
          subcategorie: this.subcategory.id,
        }))
        this.$toast('success', 'De subcategorie is verwijderd')
        this.$goto('category.edit', { categorie: this.category.id })
      } catch (e) {
        console.error(e)
        this.$toast('error', 'De subcategorie kon niet worden verwijderd')
      }
    },
  },
}
</script>
